export default "__VITE_ASSET__bVTMAfTJ__"